import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GLOSSARY_TERM_KEYS } from './Glossary.constants';
import { styles } from './Glossary.styles';
import { matchesQuery } from './Glossary.utils';

export const Glossary = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'glossary' });
	const [query, setQuery] = useState('');

	const rows = GLOSSARY_TERM_KEYS.map((key) => ({
		key,
		term: t(`TERMS.${key}.TERM`),
		tech: t(`TERMS.${key}.TECH`),
		def: t(`TERMS.${key}.DEF`),
	})).filter((row) => matchesQuery(query, row.term, row.tech, row.def));

	return (
		<>
			<header className={styles.topbar}>
				<span className="text-[12px] font-medium text-default">{t('BREADCRUMB')}</span>
			</header>
			<main className={styles.content}>
				<header>
					<p className={styles.pageEyebrow}>{t('EYEBROW')}</p>
					<h1 className={styles.pageH1}>{t('TITLE')}</h1>
					<p className={styles.pageSub}>{t('SUBTITLE')}</p>
				</header>
				<input
					type="search"
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					placeholder={t('SEARCH')}
					aria-label={t('SEARCH')}
					className={styles.search}
				/>
				{rows.length === 0 ? (
					<p className="text-[13px] text-subtle">{t('EMPTY')}</p>
				) : (
					<table className={styles.table}>
						<thead>
							<tr>
								<th className={styles.th}>{t('COL_TERM')}</th>
								<th className={styles.th}>{t('COL_TECH')}</th>
								<th className={styles.th}>{t('COL_DEF')}</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row) => (
								<tr key={row.key}>
									<td className={`${styles.td} font-semibold`}>{row.term}</td>
									<td className={`${styles.td} ${styles.tech}`}>{row.tech}</td>
									<td className={styles.td}>{row.def}</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</main>
		</>
	);
};
